export default __webpack_public_path__ + "7581497515140bcb463e0ac406745750.png";